import store from '@/store'

export function isAuthenticated () {
  return store.state.user.isAuthenticated
}

export function isAliveToken (success = () => {}, error = () => {}) {
  /**
   * Функция проверяет не протух ли токен авторизации
   * @param {function} success - Функция, вызываемая при успешной проверке
   * @param {function} error - Функция, вызываемая при ошибке
   */
  if (store.getters['auth/isCheckExpired']()) {
    store.dispatch('auth/CHECK_TOKEN_ALIVE').then(
      () => {
        success()
      }
    ).catch(error)
  } else {
    success()
  }
}

export function goToLoginPage () {
  /**
   * Функция для редиректа на страницу авторизации
   */
  const params = (new URL(document.location)).searchParams
  const from = params.get("from")
  if (from) {
    // хук для кривого редиректа
    document.location.href = process.env.VUE_APP_LOGIN_HOST + `?from=` + from
  } else {
    document.location.href = process.env.VUE_APP_LOGIN_HOST + `?from=${document.location.href}`
  }
}
